import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthAdminService } from './core/auth/service/auth-admin.service';

@Injectable()
export class AppCompanyResolverGuard implements Resolve<any> {
  constructor(private service: AuthAdminService, private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    if (route.params && route.params.companyToken) {
      return this.service.resolveCompanyToken(route.params.companyToken).pipe(
        catchError(() => {
          this.router.navigate(['/error/404']);
          return this.emptyCompany();
        })
      );
    } else {
      return this.emptyCompany();
    }
  }

  emptyCompany() {
    return of({});
  }
}
